export class Preference {
  id: number;
  value: string;
  key: string;
  value2: String;
  sort: number;

  constructor(id, value, key, value2, sort) {
    this.id = id;
    this.value = value;
    this.key = key;
    this.value2 = value2;
    this.sort = sort;
  }
}

// clase para armar el listado de preferencias
export class PreferenceItemList {
  title: string;
  key: string;
  values: Preference[];

  constructor(title, key, values) {
    this.title = title;
    this.key = key;
    this.values = values;
  }
}

// clase para guardar la lista ordenada
export class PreferenceSortSave {
  preferenceList: Preference[];

  constructor(list: Preference[]) {
    this.preferenceList = list;
  }
}
